import { Component, OnInit, ViewChild, ElementRef,
    Input, Output, EventEmitter } from '@angular/core';
import { NetworkService } from '../network.service';
import { Router, ActivatedRoute } from '@angular/router';
import { VcaAlertsService } from './../../../../../../common/vca-alerts';
import {VcaGrid} from './../../../../../../common/vca-grid/vca-grid.component';
import { NgForm } from '@angular/forms';
import { getIPScopeListingDatatableConfig } from './ipscope.dt.config';
import { Observable }  from 'rxjs/Observable';
import { Subscription } from 'rxjs/Rx';
import { NetworkConstants } from '../network-constants';
// import { Response } from '@angular/http';
const _ = require('lodash');

import { HttpResponse } from '@angular/common/http';


@Component({
    selector: 'add-edit-network',
    template: require('./add-edit-network-dialog.html')
})


export default class AddEditNetworkDialog implements OnInit {

    private network: any = {
        scope: [],
        ipScopes: []
    };
    private operationMode: number = NetworkConstants.OPERATION_MODE.ADD;
    private typeOfNetwork: number = 1;
    private showModal: boolean = false;
    private subscribeHandler: Subscription;
    private networkTypes: Array<any> = [];
    private computeContainers: Array<any> = [];
    private showScopes: boolean = false;
    private showIPPoolCreateDialog: boolean = false;
    private openIPScopeDialog: boolean = false;
    private selectedIpScope = {gateway: '', networkIpRanges: [{}]};
    private isRowSelected: boolean = false;
    private selectedIPScopeRowIndex: number = -1;
    private subscribeParamHandler: Subscription;
    private title: String = 'Add Network';
    private canChangeNetworkType: boolean = true;
    private openIpScopeForEdit: boolean = false;
    private ipScopeDialogTitle: String = 'Add IP Scope';
    private isNetworkCallInProgress: boolean = false;
    private networkOperationFailed: boolean = false;
    private errorMessage: string = '';
    private tableSettings: Object = {};
    private tableConfig: Object = {};
    private titleForOKButton: string = 'ADD';
    private canEditGatewayIP: boolean = true;
    private copyOfNwToVerify: any;
    private ipScopeOKBtnText: string = 'ADD';
    @ViewChild('ipscopeGrid') ipscopeGrid: VcaGrid;

    constructor(private networkService: NetworkService, private router: Router,
      private alert: VcaAlertsService, private activatedRoute: ActivatedRoute) {
        this.tableConfig = getIPScopeListingDatatableConfig();
        Object.assign(this.tableSettings, this.tableConfig, {'data': []});
    }

    ngOnInit() {
        this.networkTypes.push({value: NetworkConstants.NETWORK_VALUES.TRANSIT,
            label: NetworkConstants.NETWORK_NAMES.TRANSIT});
        this.networkTypes.push({value: NetworkConstants.NETWORK_VALUES.COMPUTE,
           label: NetworkConstants.NETWORK_NAMES.COMPUTE});

        this.subscribeParamHandler = this.activatedRoute.params.subscribe(params => {
          let id = params['id'];
          if (id) {
              this.getNetwork(id);
              this.title = 'Edit Network';
              this.titleForOKButton = 'SAVE';
              this.operationMode = NetworkConstants.OPERATION_MODE.EDIT;
              this.canChangeNetworkType = false;
            }
        });

        this.getComputeContainers();
    }

    cancel() {
        this.router.navigate(['services/networking/network']);
    }

    upsertNetwork() {
        this.isNetworkCallInProgress = true;
        this.networkOperationFailed = false;
        if (this.operationMode === NetworkConstants.OPERATION_MODE.ADD) {
             this.subscribeHandler = this.networkService.createNetwork(this.network)
            .subscribe(
                networks => {
                    this.isNetworkCallInProgress = false;
                    this.networkService.getAllNetworks();
                    this.router.navigate(['services/networking/network']);
                },
                error => this.handleNetworkOpreationError(error),
                () => this.logOperationCompleted('create network operation completed')
            );
        } else {
            this.subscribeHandler = this.networkService.updateNetwork(this.network)
                .subscribe(
                    networks => {
                        this.isNetworkCallInProgress = false;
                        this.networkService.getAllNetworks();
                        this.router.navigate(['services/networking/network']);
                    },
                    error => this.handleNetworkOpreationError(error),
                    () => this.logOperationCompleted('create network operation completed')
                );
        }
    }

    getNetwork(networkId) {
            let me = this;
            this.subscribeHandler = this.networkService.getNetwork(networkId)
            .subscribe(
                (network:any) => {
                    this.network = network;
                    this.copyOfNwToVerify = _.cloneDeep(network);
                    this.typeOfNetwork = network.scope && network.scope.length > 0 ?
                    NetworkConstants.NETWORK_VALUES.COMPUTE :
                    NetworkConstants.NETWORK_VALUES.TRANSIT;
                    this.showScopes =
                    (this.typeOfNetwork === NetworkConstants.NETWORK_VALUES.COMPUTE);
                },
                error => this.logError(error, 'get network operation failed'),
                () => this.logOperationCompleted('get network operation completed')
            );
    }

    onNetworkTypeChanged(networkType) {
        if (Number(networkType) === Number(NetworkConstants.NETWORK_VALUES.TRANSIT)) {
            this.showScopes = false;
            return;
        }
        if (this.network.scope.length === 0) {
            this.network.scope = [this.computeContainers[0].scopeId];
        }
        this.showScopes = true;
    }

    onIpScopeCreate() {
        this.canEditGatewayIP = true;
        this.ipScopeDialogTitle = 'Add IP Scope';
        this.ipScopeOKBtnText = 'ADD';
        this.openIpScopeForEdit = false;
        this.selectedIpScope = {gateway: '', networkIpRanges: [{}]};
        this.openIPScopeDialog = true;
    }

    onIpScopeEdit() {
        if (this.operationMode === NetworkConstants.OPERATION_MODE.EDIT) {
            if (this.isIpScopeExistsInCollection(this.copyOfNwToVerify.ipScopes, this.selectedIpScope) !== -1) {
                this.canEditGatewayIP = false;
            } else {
                 this.canEditGatewayIP = true;
            }
        }
        this.ipScopeOKBtnText = 'SAVE';
        this.ipScopeDialogTitle = 'Edit IP Scope';
        this.openIpScopeForEdit = true;
        this.openIPScopeDialog = true;
    }

    onIpScopeDialogClosed(event) {
        this.openIPScopeDialog = false;
        this.ipscopeGrid.deselectRow();
    }

    onIpScopeDialogSave(event) {
        this.openIPScopeDialog = false;
        if (this.openIpScopeForEdit) {
                this.network.ipScopes[this.selectedIPScopeRowIndex] = event.ipScope;
        } else {
            if (typeof this.network.ipScopes === "undefined") {
                this.network.ipScopes = [];
            }
            this.network.ipScopes.push(event.ipScope);
        }
        this.network.ipScopes = [].concat(this.network.ipScopes);
        this.isRowSelected = false;
        this.selectedIPScopeRowIndex = -1;
    }

    onIPScopeSelected(event) {
        this.isRowSelected = true;
        if (event && event.value && event.value instanceof Array ) {
           if (event.value[0]) {
                this.selectedIpScope = _.cloneDeep(event.value[0]);
                this.selectedIPScopeRowIndex = this.isIpScopeExistsInCollection(this.network.ipScopes, event.value[0]);
                this.isRowSelected = true;
           } else {
                this.selectedIpScope = {gateway: '', networkIpRanges: [{}]};
                this.isRowSelected = false;
                this.selectedIPScopeRowIndex = -1;
           }
        }
    }

    onIpScopeDelete(event) {
        if (this.selectedIPScopeRowIndex !== -1) {
            let index: number = this.isIpScopeExistsInCollection(this.network.ipScopes, this.selectedIpScope);
            this.network.ipScopes.splice(index, 1);
            this.network.ipScopes = [].concat(this.network.ipScopes);
            if (this.operationMode === NetworkConstants.OPERATION_MODE.EDIT) {
                let index: number = this.isIpScopeExistsInCollection(this.copyOfNwToVerify.ipScopes, this.selectedIpScope);
                if (index !== -1) {
                    this.copyOfNwToVerify.ipScopes.splice(this.selectedIPScopeRowIndex, index);
                }
            }
        }
    }

    getComputeContainers() {
        this.subscribeHandler = this.networkService.getComputeContainer()
            .subscribe(
            (containers: any) => {
                this.computeContainers = containers;
                this.showModal = true;
            },
            error => this.logError(error, 'get all networks'),
            () => this.logOperationCompleted('get all networks')
        );
    }

    onDialogClose(event) {
        if (!event) {
            this.cancel();
        }
    }

    logError(error, origin: String = '') {
        console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
    }

    logOperationCompleted(msg: string) {
        console.log('Operation Completed: ', msg);
    }

    handleNetworkOpreationError(error) {
        this.networkOperationFailed = true;
        this.isNetworkCallInProgress = false;
    }

    isIpScopeExistsInCollection(collection, ipScope): number {
        let objectToCompare = {
            'prefixLength' : ipScope.prefixLength,
            'networkIpRanges': ipScope.networkIpRanges
        };
        // As Gateway is optional now
        if (ipScope.gateway) {
            objectToCompare['gateway'] = ipScope.gateway;
        }
        let index = _.findIndex(collection, objectToCompare);
        return index;
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/networks/dialogs/add-edit-network-dialog.component.ts